import { createSystemContextPorts } from '../app/system_runtime_context.js';
import { createRenderSceneService } from './render_scene_service.mjs';
import {
  getRenderSceneInvalidationState,
  subscribeRenderSceneInvalidation
} from './render_scene_invalidation.mjs';

const contextPorts = createSystemContextPorts(() => false);

// The singleton contains no backend and performs no scene requests on its own.
// G04 will explicitly request/read contributions for the active viewport.
const scenes = createRenderSceneService({
  getContext() {
    const current = contextPorts.current();
    if (!current?.projectToken) return null;
    const invalidation = getRenderSceneInvalidationState();
    return {
      projectToken: current.projectToken,
      sheetId: current.sheetId,
      view: current.view,
      epoch: invalidation.epoch,
      modelRevision: current.revision,
      geometryRevision: invalidation.geometryRevision,
      // Existing asset ports publish a joint derived-geometry invalidation.
      // Conservatively invalidate both dependencies until independent asset revisions exist.
      assetRevision: invalidation.geometryRevision
    };
  },
  onError(issue) {
    console.warn(`[render-scene] ${issue.owner}: ${issue.code}`);
  }
});

subscribeRenderSceneInvalidation(event => {
  if (event.kind === 'project') scenes.reset('project-transition');
  else scenes.synchronizeContext();
});

export const registerRenderSceneProvider = scenes.registerProvider;
export const unregisterRenderSceneProvider = scenes.unregisterProvider;
export const requestRenderScene = scenes.request;
export const getRenderSceneSnapshot = scenes.getSnapshot;
export const getRenderSceneStatus = scenes.status;
export const releaseRenderSceneOwner = scenes.releaseOwner;
